import { useRef } from "react";
import ModalPop from "./ModalPop";

const Event2 = () => {
  const popupRef = useRef<HTMLDivElement>(null);

  const openfunc = () => {
    popupRef.current!.style.display = "block";
  };

  const closefunc = () => {
    popupRef.current!.style.display = "none";
  };
  return (
    <div className="bg-secondary relative w-full h-full 3xl:px-[calc((100%-var(--container))/2)] mx-auto">
      <img
        onClick={openfunc}
        data-aos="fade-up"
        className="hidden lg:block"
        src="/images/eventPc2.webp"
        alt="비우고 채우고 생전정리·빈집정리 이벤트 안내"
        loading="lazy"
      />
      <img
        onClick={openfunc}
        data-aos="fade-left"
        className="block lg:hidden pt-14"
        src="/images/eventM3.webp"
        alt="비우고 채우고 이벤트 상세 안내"
        loading="lazy"
      />
      <ModalPop popupRef={popupRef} closefnc={closefunc} />
    </div>
  );
};

export default Event2;
